<template>
  <v-form class="nickname">
    <v-avatar 
      size="72" 
      class="profile-image" 
      :id="userType == 'challenger' ? 'challenger' : 'helper'"
    >
      <img 
        :src="userType == 'challenger' ? challenger : helper" 
        :alt="nickname"
      >
    </v-avatar>
    <v-text-field
    maxlength="15" 
      v-model="nickname"
      hide-details
    ></v-text-field>
    <v-btn class="customButton" @click="submit">저장</v-btn>
    <span 
      v-if="alert"
      class="alert"
    >
      <v-icon class="alertIcon">mdi-alert</v-icon>
      {{ alertMessage }}
    </span>
  </v-form>
</template>
<script>
export default {
  name: "Nickname",
  data() {
    return {
      nickname: undefined,
      challenger: undefined,
      helper: undefined,
      alert: false,
      alertMessage: undefined,
      userType: undefined
    };
  },
  mounted() {
    // this.nickname = this.$store.getters.nickname;
    const localStorageUser = window.localStorage.getItem("pushToken");
    if(localStorageUser == "challengertoken"){
      this.nickname = "user1";
      this.userType = "challenger";
    }else{
      this.nickname = "user2";
      this.userType = "helper";
    }
    this.getBackgroundImage();
  },
  computed: {
    // userType() {
    //   return this.$store.getters.userType;
    // },
    // challengeId() {
    //   return this.$store.getters.challengeId;
    // },
  },
  methods: {
    submit() {
      // this.$store
      //   .dispatch("nickname", {
      //     nickname: this.nickname,
      //   })
      //   .catch((error) => {
      //     this.alert = true;
      //     this.alertMessage = "닉네임 변경에 실패하였습니다. 다시 시도해주세요. :(";
      //     return false;
      //   })
      //   .then(() => {
      //   });
      this.alert = true;
      this.alertMessage = "변경되었습니다.";
    },
    getBackgroundImage() {
      // this.$axios
      //   .get("/challenges/" + this.challengeId + "/background")
      //   .then((response) => {
      //     this.challenger = response.data.challenger;
      //     this.helper = response.data.helper;
      //   });
      this.challenger = require("@/assets/images/home/user1.png");
      this.helper = require("@/assets/images/home/user2.png");
    },
  },
};
</script>
<style lang="scss">
.nickname{
  margin-bottom: 32px;
  display: flex;
  justify-content: center;
  position: relative;

  .profile-image{
    margin-right: 16px;
  }

  .customButton{
    position: absolute;
    right: 0; 
    bottom: 16px;
  }
  .v-text-field input{
    padding: 24px 90px 24px 0px;
    font-weight: 700;
    letter-spacing: -0.5px;
  }
}
</style>